import { Checkbox } from "antd";
import styled from "styled-components";

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    width: 250px;
    padding: 8px 16px 16px;
    overflow: hidden;
`;

export const ListContainer = styled.div`
    display:flex;
    flex-direction: column;
    width: 100%;
    height: 180px;
    overflow-y: auto;
    border: 1px solid ${props => props.theme.components.tableColumnsFilter.borderColor};
    border-radius: 4px;
`;

export const ListItemWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr min-content;
    column-gap: 16px;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.components.tableColumnsFilter.dividerColor};

    &:hover {
        background-color: ${props => props.theme.components.tableColumnsFilter.hoverBgColor};
    }
`;

export const CheckboxStyled = styled(Checkbox)`
    padding: 12px 4px 12px 8px;
`;

export const ButtonsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 8px;
    align-self: flex-end;
    width: fit-content;
    padding-top: 4px;

`;
